<div id="digital-income-employment-order-container" [ngClass]="{isTruv: provider === 'Truv'}"></div>
